import React from 'react'
import { IFormProps } from '../../lib/types'
import { FormikProps, Formik } from 'formik'
import { Input, Button, Line, GoogleReCaptcha } from '../../lib/components'
import { PASSWORD_ERROR } from '../../lib/utils/message'

const AdminLoginPresenter = ({
  initialValues,
  handleFormSubmit,
  validationSchema,
  reRef,
}: IFormProps) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleFormSubmit}
    >
      {(formik) => {
        const {
          values,
          touched,
          errors,
          dirty,
          handleChange,
          handleSubmit,
          setFieldValue,
        }: FormikProps<typeof initialValues> = formik
        return (
          <form>
            <Input
              labelText='Admin/Dev Email'
              name='adminEmail'
              placeholder='Enter your email'
              type='text'
              data-testid='admin-email-input'
              required
              value={values.adminEmail}
              handleChange={handleChange(initialValues.adminEmail)}
              dirty={dirty}
              errors={{ adminEmail: !!errors && errors.adminEmail ? errors.adminEmail : null }}
              touched={{ adminEmail: !!touched && !!touched.adminEmail }}
            />
            <Input
              labelText='Client Email'
              name='investorEmail'
              placeholder='Enter the client email'
              type='text'
              data-testid='investor-email-input'
              required
              value={values.investorEmail}
              handleChange={handleChange(initialValues.investorEmail)}
              dirty={dirty}
              errors={{
                investorEmail: !!errors && errors.investorEmail ? errors.investorEmail : null,
              }}
              touched={{ investorEmail: !!touched && !!touched.investorEmail }}
            />
            <div className='mt-16'>
              <Input
                labelText='Admin Password'
                name='password'
                placeholder=''
                required
                type='password'
                data-testid='password-input'
                value={values.password}
                infoText={PASSWORD_ERROR}
                handleChange={handleChange(initialValues.password)}
                dirty={dirty}
                errors={{
                  password: !!errors && errors.password ? errors.password : null,
                }}
                touched={{ password: !!touched && !!touched.password }}
              />
            </div>

            <Line />

            <GoogleReCaptcha
              handleChange={(value) => setFieldValue('reCaptchaToken', value)}
              reCaptchaRef={reRef}
              size='invisible'
            />

            <Button
              text='Log in'
              classes={['mb-24']}
              variant='primary-btn'
              handleClick={handleSubmit}
            />
          </form>
        )
      }}
    </Formik>
  )
}

export { AdminLoginPresenter }
